import {Component, OnInit, NgZone} from '@angular/core';
import {NgxFileDropEntry, FileSystemFileEntry} from 'ngx-file-drop';
import {Router} from '@angular/router';
import {environment} from 'src/environments/environment';
import {TrustiiService} from 'src/app/services/trustii.service';
import {SessionService} from 'src/app/services/session.service';
import {FileService} from 'src/app/services/file.service';
import {UploadService, FileType} from 'src/app/services/async.service';
import {DialogService} from 'src/app/services/dialog.service';
import {tap, filter, distinctUntilChanged} from 'rxjs/operators';

@Component({
  selector: 'app-enterprise-dataset-upload',
  templateUrl: './dataset-upload.component.html',
  styleUrls: ['./dataset-upload.component.scss']
})
export class EnterpriseDatasetUploadComponent implements OnInit {
  devMode = false;
  filename = null;
  error: string;
  progress = 0;
  inProgress = false;
  showTermsAndConditionAcceptWarning = false;
  public files: NgxFileDropEntry[] = [];

  constructor(private router: Router, private ngZone: NgZone, private dialogService: DialogService, private trustiiService: TrustiiService,
              private sessionService: SessionService, private fileService: FileService, private uploadService: UploadService) {
  }

  ngOnInit() {
    this.devMode = !environment.production;
    if (!this.sessionService.canUploadDataset()) {
      this.dialogService.openAlertDialog(
        '350px',
        'You have reached the dataset limit.',
        'ERROR',
        'Ok',
        'modal-warning'
      );
      this.router.navigateByUrl('/enterprise/datasets');
      return;
    }
  }

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    const numberOfFile = files.length;
    this.files.forEach((droppedItem, index) => {
      if (!droppedItem.fileEntry.isFile) {
        this.dialogService.openAlertDialog(
          '350px',
          '"' + droppedItem.relativePath + '" is not a file',
          'ERROR',
          'Ok',
          'modal-warning'
        );
        return;
      }
      const fileEntry = droppedItem.fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        const formData = new FormData();
        this.filename = file.name;
        if (file.name.split('.').pop().toLowerCase() !== 'csv') {
          const alertCsv = '"' + droppedItem.relativePath + '" is not supported. We support only CSV formatted dataset as of now.';
          this.dialogService.openAlertDialog(
            '350px',
            alertCsv,
            'ERROR',
            'Ok',
            'modal-warning'
          );
          return;
        }
        if (file.size > (this.fileService.getFleSizeLimit() * 1000)) {
          const alertMessage = '"' + droppedItem.relativePath +
            '" exceeds the supported size limit. we do not support file size more than ' +
            '1GB as of today. Please try again with file size within limit.';
          this.dialogService.openAlertDialog(
            '350px',
            alertMessage,
            'ERROR',
            'Ok',
            'modal-warning'
          );
          return;
        }

        if (!this.sessionService.canUploadDataset(file.size)) {
          this.dialogService.openAlertDialog(
            '350px',
            'You have reached the dataset limit',
            'ERROR',
            'Ok',
            'modal-warning'
          );
          this.router.navigateByUrl('/enterprise/datasets');
          return;
        }

        if (this.sessionService.willReachDatasetLimit(file.size)) {
          if (this.sessionService.getVendor().planId < 4) {
            this.dialogService.openAlertDialog(
              '350px',
              'You have reached your monthly limit, you can\'t upload more files.',
              'ERROR',
              'Ok',
              'modal-warning'
            );
            return;
          } else {
            const message = 'You will reach your dataset limit for this month, if you continue you will pay extra fees. Do you confirm ?';
            this.dialogService.openConfirmDialog(message).pipe(
              distinctUntilChanged(),
              filter((result) => result && result.data === 'confirmation'),
              tap(() => this.uploadDataset(formData, file, index, numberOfFile))
            ).subscribe();
            return;
          }
        }
        this.uploadDataset(formData, file, index, numberOfFile);
      });
    });
  }

  uploadDataset(formData: FormData, file: File, index: number, numberOfFile: number) {
    formData.append('datasetFile', file, this.filename);
    this.uploadService.upload(FileType.TRAINING, this.filename, file.size, formData);
    if (index === numberOfFile - 1) {
      this.ngZone.run(() => this.router.navigateByUrl('enterprise/datasets')).then();
    }
  }

  downloadGuide() {
    const link = document.createElement('a');
    link.download = 'Trustii-io Data Challenge Setup Guide.pdf';
    link.href = 'assets/pdf/DataChallengeSetupGuide.pdf';
    link.click();
  }
}
